// class PriceSlider extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const min = document.querySelector(".min-range");
//     const max = document.querySelector(".max-range");

//     const minLabel = document.querySelector(".price-min");
//     const maxLabel = document.querySelector(".price-max");

//     min.addEventListener("input", (event) => {
//       minLabel.textContent =
//         `${minLabel.dataset.currency}${event.target.value}.00`;
//     });

//     max.addEventListener("input", (event) => {
//       maxLabel.textContent =
//         `${maxLabel.dataset.currency}${event.target.value}.00`;
//     });
//   }
// }

// customElements.define("price-slider", PriceSlider);

class PriceSlider extends HTMLElement {
  constructor() {
    super();

    this.minRange = this.querySelector('.min-range');
    this.maxRange = this.querySelector('.max-range');

    // Original values rendered by Liquid
    this.initialMin = this.minRange.defaultValue;
    this.initialMax = this.maxRange.defaultValue;

    this.minRange.addEventListener('change', this.onRangeChange.bind(this));
    this.maxRange.addEventListener('change', this.onRangeChange.bind(this));
  }

  onRangeChange() {
    const currentMin = this.minRange.value;
    const currentMax = this.maxRange.value;

    // Prevent filter submit if unchanged
    if (
      currentMin === this.initialMin &&
      currentMax === this.initialMax
    ) {
      return;
    }

    // Dawn filter submit
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

customElements.define('price-slider', PriceSlider);